import { BiDesktop } from "react-icons/bi";
import { FaCheckCircle } from "react-icons/fa";
import { GiMoneyStack } from "react-icons/gi";
import { IoHardwareChipOutline } from "react-icons/io5";
import { MdLaptopMac, MdTabletMac } from "react-icons/md";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";

export default function SectionFour()
{
    const benefits = [
    "Easy pickup & delivery",
    "Certified Technicians",
    "Transparent Pricing",
    "Same-day Repair option",
    "Track your repair"
  ];

  const services = [
    { label: "Laptop Repair", icon:MdLaptopMac },
    { label: "Desktop Repair", icon: BiDesktop },
    { label: "Chip Repair", icon: IoHardwareChipOutline},
    { label: "Mac book/iPad Repair", icon: MdTabletMac}
  ];
  const navigate=useNavigate();
  const handleBookService = () => {
      const storedUser = localStorage.getItem("customeruser");
  
      if (storedUser) {
        navigate("/bookservice");
      } else {
        toast.warning("Please login to continue");
        setTimeout(() => navigate("/login"), 1000);
        return;
      }
  };
  
    return(
    <section className=" px-5 py-7">

      <div className="flex flex-col md:flex-row justify-between gap-8">
        <div className="flex flex-col gap-3 md:w-1/2 pl-5 items-start">
          <h2 className="text-xl md:text-2xl xl:text-3xl font-semibold pb-5">
            Get best and affordable repair services at your doorstep!
          </h2>
          {benefits.map((item, i) => (
            <div key={i} className="flex items-center gap-2 text-gray-800 text-sm md:text-base xl:text-lg">
              <FaCheckCircle className="text-green-600" />
              <span>{item}</span>
            </div>
          ))}
          <div className="flex flex-col bg-gray-200 px-2 md:px-5 rounded-lg py-2">
            <p className="text-sm md:text-base xl:text-lg font-medium">Get free estimation in one click!</p>
            <div className="flex flex-row items-center justify-center space-x-3">
                <div className="pt-4">
                  <GiMoneyStack className="text-xl md:text-3xl xl:text-3xl text-center"/>
                </div>
                
                <button className="mt-5 bg-red-800 text-white font-semibold rounded px-4 py-2 w-fit text-xs md:text-sm xl:text-base"
                onClick={handleBookService}>
                    Get Estimation
                </button>
            </div>
          </div>
          
        </div>

        <div className="grid grid-cols-2 gap-5 md:w-1/2 border border-gray-600 rounded-lg p-3 md:p-5">
          {services.map((service, i) => (
            <div
              key={i}
              className="p-4 flex flex-col space-y-1 items-center hover:shadow-md transition hover:bg-blue-50 hover:border hover:border-blue-100 rounded-2xl"
            >
              <service.icon className="text-violet-800 text-4xl md:text-5xl xl:text-6xl"/>
              <p className="font-medium text-base md:text-lg xl:text-xl text-center">{service.label}</p>
            </div>
          ))}
        </div>
      </div>

    </section>
    );
}